export namespace Constants {
    export namespace ClienteInmobiliario {
        export const URL_TEMPLATE_AUTORIZACION_CLIENTE_PERSONA_FISICA: string = "clientes-inmobiliarios:templates/autorizacion_cliente_persona_fisica_V1.docx";
        export const URL_TEMPLATE_AUTORIZACION_CLIENTE_PERSONA_JURIDICA: string = "clientes-inmobiliarios:templates/autorizacion_cliente_persona_juridica_V1.docx";
    }

}